import React, { useState, useEffect } from 'react';
import { Button } from '../ui/button';
import { Download, X } from 'lucide-react';

const PWAInstallPrompt = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      const dismissed = sessionStorage.getItem('pwa-dismiss');
      if (!dismissed) setShowBanner(true);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleInstall = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    const { outcome } = await deferredPrompt.userChoice;
    if (outcome === 'accepted') setShowBanner(false);
    setDeferredPrompt(null);
  };

  const handleDismiss = () => {
    setShowBanner(false);
    sessionStorage.setItem('pwa-dismiss', '1');
  };

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-20 left-4 right-4 lg:bottom-4 lg:left-auto lg:right-4 lg:w-80 z-50 animate-in slide-in-from-bottom-4" data-testid="pwa-install-banner">
      <div className="bg-slate-900 text-white rounded-xl p-4 shadow-2xl border border-slate-700">
        <div className="flex items-start gap-3">
          <div className="w-10 h-10 rounded-lg bg-blue-600 flex items-center justify-center flex-shrink-0">
            <Download className="w-5 h-5" />
          </div>
          <div className="flex-1">
            <p className="font-bold text-sm">Instaleaza MAINTIX</p>
            <p className="text-xs text-slate-400 mt-0.5">Acces rapid de pe ecranul principal</p>
            <div className="flex gap-2 mt-3">
              <Button size="sm" className="bg-blue-600 hover:bg-blue-700 h-7 text-xs" onClick={handleInstall} data-testid="pwa-install-btn">
                Instaleaza
              </Button>
              <Button size="sm" variant="ghost" className="text-slate-400 h-7 text-xs" onClick={handleDismiss}>
                Mai tarziu
              </Button>
            </div>
          </div>
          <button onClick={handleDismiss} className="text-slate-500 hover:text-white">
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
